import React, { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import FormAlert from "../../../../components/UI/FormAlert/FormAlert";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";
import EfisModalParteServicoExcluir from "../../../../components/UI/EfisModal/EfisModalParteServicoExcuir";

const useExcluirParteServicoOs = ({ formik }) => {
  const [showExcluiConfirm, setshowExcluiConfirm] = useState({
    title: null,
    body: null,
    show: false,
  });

  const [Codigo, setCodigo] = useState("");

  const { request: requestExclui, data: dataExclui, errors: errorsExclui, isLoading: isLoadingExclui } = useApiClient();

  const { setErrors } = formik;

  useEffect(() => {
    if (!dataExclui && !errorsExclui) return;

    if (dataExclui) {
      toast.success("Parte de Serviço excluída com sucesso.");
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    }

    if (errorsExclui) {
      setErrors((curr) => ({ ...curr, ...errorsExclui }));
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }

    setshowExcluiConfirm({ show: false });
  }, [setshowExcluiConfirm, dataExclui, errorsExclui, setErrors]);

  const excluirDocumentoPs = useCallback(
    (sqParteServico, texto) => {
      requestExclui(apiRoutes.fiscalizacao.parteservico.excluirParteServico, {
        sqParteServico,
        textoJustificativa: texto,
      });
    },
    [requestExclui],
  );

  const { request: requestVerificaPs, data: dataVerificaPs } = useApiClient();

  useEffect(() => {
    if (dataVerificaPs) {
      const mensagem = dataVerificaPs.result;
      if (mensagem === "" || mensagem == null) {
        setshowExcluiConfirm({
          title: "Justificativa para cancelamento",
          body: `Cancelar PS Nº ${Codigo}`,
          show: true,
          codigo: Codigo,
          situacao: "N",
          justificar: true,
        });
      } else {
        setshowExcluiConfirm({
          title: "Atenção!",
          body: `${mensagem}`,
          show: true,
          justificar: false,
        });
      }
    }
  }, [dataVerificaPs, setshowExcluiConfirm, Codigo]);

  const verificaPsExcluir = useCallback(
    (codigo) => {
      setCodigo(codigo);
      requestVerificaPs(apiRoutes.fiscalizacao.parteservico.verificaParteServico, { sqParteServico: codigo });
    },
    [requestVerificaPs],
  );

  const excluirPsModal = (
    <>
      <FormAlert formik={formik} data={dataExclui} errors={errorsExclui} isLoading={isLoadingExclui} dismissible />
      <EfisModalParteServicoExcluir
        show={showExcluiConfirm.show}
        title={showExcluiConfirm.title}
        loadingConfirmationAction={isLoadingExclui}
        codigo={showExcluiConfirm.codigo}
        situacao={showExcluiConfirm.situacao}
        justificar={showExcluiConfirm.justificar}
        primaryLabel="Confirmar"
        closeHandler={() => setshowExcluiConfirm({ show: false })}
        confirmationHandler={(codigo, texto) => {
          excluirDocumentoPs(codigo, texto);
        }}
        body={showExcluiConfirm.body}
      />
    </>
  );

  return {
    excluirPsModal,
    setshowExcluiConfirm,
    verificaPsExcluir,
  };
};

export default useExcluirParteServicoOs;
